<cass-core-toolbar></cass-core-toolbar>
<div class="login-container">
	<h1>{{ "LOGIN.LOGIN_FORM_TITLE" | translate }}</h1>
	<mat-card>
		<mat-card-content>
			<img src="branding/home-account.png" />
			<form>
				<mat-form-field>
					<mat-label>{{ "LOGIN.LOGIN_FORM_FIELD_EMAIL" | translate }}</mat-label>
					<input matInput required [formControl]="email" #emailFormField id="email" name="email" autocomplete="username">
					<mat-error [cassErrorForFormControl]="email"></mat-error>
				</mat-form-field>
				<mat-form-field>
					<mat-label>{{ "LOGIN.LOGIN_FORM_FIELD_PASSWORD" | translate }}</mat-label>
					<input matInput type="{{ isPasswordShown ? 'text' : 'password' }}" required [formControl]="password" #passwordFormField id="password" name="password" autocomplete="current-password">
					<button mat-icon-button matSuffix (click)="isPasswordShown = !isPasswordShown">
						<mat-icon>{{ isPasswordShown ? 'visibility_off' : 'visibility' }}</mat-icon>
					</button>
					<mat-error [cassErrorForFormControl]="password"></mat-error>
				</mat-form-field>
				<div *ngIf="loginErrorMessage" class="cass-login-error-container">
					<div>{{ loginErrorMessage }}</div>
				</div>
				<div class="cass-group-box">
					<button mat-raised-button color="accent" type="submit" (click)="login()">{{ "LOGIN.LOGIN_BUTTON_LABEL" | translate }}</button>
				</div>
			</form>
			<div *ngIf="(appConfigService.config$ | async)?.registrationEnabled">
				<div class="cass-group-box">{{ "LOGIN.OR_TEXT" | translate }}</div>
				<div class="cass-group-box">
					<button mat-stroked-button color="primary" routerLink="/register">{{ "LOGIN.CREATE_AN_ACCOUNT_BUTTON_LABEL" | translate }}</button>
				</div>
			</div>
			<div>
				<div class="cass-group-box">{{ "LOGIN.OR_TEXT" | translate }}</div>
				<div class="cass-group-box">
					<p>{{ "LOGIN.FORGOT_PASSWORD_TEXT" | translate }}&nbsp;<a routerLink="/forgot-password">{{ "LOGIN.CLICK_HERE_HREF" | translate }}</a></p>
				</div>
			</div>
		</mat-card-content>
	</mat-card>
</div>
